import PageLayout from '@app-studio-web/ui/components/PageLayout'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'

export default function SplashPage() {
  const { t } = useTranslation()

  return (
    <PageLayout>
      <div className="flex grow flex-col items-center justify-center text-center">
        <h1 className="text-primary mb-3 font-serif text-3xl font-bold">
          {t('pages.onboarding.splash.title', {
            defaultValue: "Let's find your number.",
          })}
        </h1>
        <p className="text-muted mb-10 max-w-sm text-base leading-relaxed">
          {t('pages.onboarding.splash.subtitle', {
            defaultValue:
              "We'll analyze your career at the task level — the actual work you do every day — and show you exactly where AI is, and isn't, a threat.",
          })}
        </p>

        <Form method="post" className="w-full max-w-[340px]">
          <button
            className="bg-accent w-full rounded-2xl px-7 py-4 text-lg font-semibold text-white transition hover:-translate-y-0.5 hover:shadow-lg"
            type="submit"
          >
            {t('pages.onboarding.splash.cta', {
              defaultValue: 'Find My Number',
            })}
          </button>
        </Form>

        <p className="text-muted mt-6 text-xs">
          {t('pages.onboarding.splash.smallText', {
            defaultValue: '3 minutes',
          })}
        </p>
      </div>
    </PageLayout>
  )
}
